import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('Wrapper')(css({
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '3px',
    border: 1,
    borderColor: 'grey.2',
    backgroundColor: 'white',
    padding: 'default',
}));
themeStyles.addBaseStyles('AddressWrapper')(css({
    display: 'flex',
    flexDirection: 'column',
    gap: 'xxs',
}));
themeStyles.addBaseStyles('HeaderWrapper')(css({
    display: 'flex',
    justifyContent: 'space-between',
    gap: 's',
}));
themeStyles.addBaseStyles('DealerName')(css({
    fontFamily: 'bold',
}));
themeStyles.addBaseStyles('Distance')(css({
    color: 'grey.0',
    width: ['110px', '110px', '122px'],
    fontSize: '12px',
    lineHeight: ['18px', '18px', '16px'],
    pt: 'xxs',
    textAlign: 'right',
}));
themeStyles.addBaseStyles('Contact')(css({
    color: 'blue',
}));
export default themeStyles;
